import React, { useState, useEffect, useCallback } from "react";

import { useHistory, useLocation, useParams } from "react-router";

import { Form, Formik, Field, useFormikContext } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import ServicoAcolhimentoService from "../../../../../main/services/ServicoAcolhimentoService";

import {
  Flex,
  Button,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Box,
  GridItem,
  RadioGroup,
  Stack,
  Grid,
} from "@chakra-ui/react";

import LoadingSpinner from "../../../../components/LoadingSpinner";

import { hasFormChanged } from "../../../../utils/hasFormChanged";
import { useAppContext } from "../../../../../Context/MessageContextProvider";
import Group from "../../Visualizar/Group";
import SemRegistros from "../../../../components/SemRegistros";
import {
  criancaFunc,
  servicoAcolhimentoFunc,
} from "../../../../../helpers/Funcionalidades";
import { useAuthProvider } from "../../../../../Context/AuthProvider";
import { RadioButtonField } from "../../../../components/RadioButtonField";
import { scrollToFieldAnexo } from "../../../../utils/scrollToFIeldAnexo";

const CadastrarApadrinhamentoServico = () => {
  const { id } = useParams();
  const history = useHistory();
  const { setCadastrarApadrinhamentoServ, idPJ } = useAppContext();
  const { roleKeycloack, user } = useAuthProvider();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const idTipoPendencia = searchParams.get("idTipoPendencia");

  const [loading, setLoading] = useState(true);
  const [initialValues] = useState({
    mantemProgramaApadrinhamento: "",
    programaInscritoCmdca: "",
  });

  const scrollToField = useCallback(
    (ref) => {
      scrollToFieldAnexo(idTipoPendencia, ref);
    },
    [idTipoPendencia],
  );

  useEffect(() => {
    ServicoAcolhimentoService.getProgramaApadrinhamentoServico(id)
      .then((res) => {
        Swal.fire({
          title: "Atenção!",
          text: "Já existe um Programa de Apadrinhamento cadastrado para este Serviço de Acolhimento!",
          icon: "warning",
          confirmButtonText: "Fechar",
          confirmButtonColor: "#169499",
        }).then(() => {
          history.push(`/servico-acolhimento/visualizar-apadrinhamento/${id}`);
        });
      })
      .catch((erro) => {
        if (erro.response) {
          if (erro.response.data.status !== 404) {
            Swal.fire({
              title: "Atenção!",
              text: "Já existe um Programa de Apadrinhamento cadastrado para este Serviço de Acolhimento!",
              icon: "warning",
              confirmButtonText: "Fechar",
              confirmButtonColor: "#169499",
            }).then(() => {
              history.push(
                `/servico-acolhimento/visualizar-apadrinhamento/${id}`,
              );
            });
          } else {
            setLoading(false);
          }
        }
      });
  }, [history, id]);

  const FocusClearField = () => {
    const { values, setFieldValue } = useFormikContext();

    useEffect(() => {
      if (values.mantemProgramaApadrinhamento) {
        setFieldValue(
          "mantemProgramaApadrinhamento",
          values.mantemProgramaApadrinhamento,
        );
      }
      if (values.programaInscritoCmdca) {
        setFieldValue("programaInscritoCmdca", values.programaInscritoCmdca);
      }
    }, [values, setFieldValue]);

    return null;
  };

  const schema = Yup.object().shape({
    mantemProgramaApadrinhamento: Yup.string().required(
      "Este campo é obrigatório ",
    ),
    programaInscritoCmdca: Yup.string().when("mantemProgramaApadrinhamento", {
      is: "S",
      then: Yup.string().required("Este campo é obrigatório!"),
      otherwise: Yup.string().nullable(),
    }),
  });

  const handleSubmit = (values, actions) => {
    setTimeout(() => {
      const { mantemProgramaApadrinhamento, programaInscritoCmdca } = values;

      const valuesToSend = {
        mantemProgramaApadrinhamento: mantemProgramaApadrinhamento ?? null,
        programaInscritoCmdca:
          mantemProgramaApadrinhamento === "S" ? programaInscritoCmdca : "N",
      };

      ServicoAcolhimentoService.postProgramaApadrinhamentoServico(
        id,
        valuesToSend,
      )
        .then((res) => {
          Swal.fire({
            title: "Sucesso!",
            text: "Registro cadastrado com sucesso!",
            icon: "success",
            confirmButtonText: "Continuar",
            confirmButtonColor: "#169499",
          }).then(function () {
            history.goBack();
            setCadastrarApadrinhamentoServ(false);
          });
          actions.setSubmitting(false);
        })
        .catch((error) => {
          console.log(error?.response?.data);
          Swal.fire({
            title: "Atenção!",
            text: error?.response?.data?.message
              ? error.response.data.message
              : "",
            icon: "error",
            confirmButtonText: "Fechar",
            confirmButtonColor: "#169499",
          }).finally(() => {
            actions.setSubmitting(false);
          });
        });
    }, 200);
  };

  return roleKeycloack &&
    (roleKeycloack.includes(
      servicoAcolhimentoFunc.cadastrarApadrinhamentoServ,
    ) ||
      (roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) &&
        user?.orgaoExterno?.includes(idPJ))) ? (
    !loading ? (
      <Formik
        validationSchema={schema}
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {(props) => (
          <Form>
            <FocusClearField />
            {setCadastrarApadrinhamentoServ(
              hasFormChanged(initialValues, props.values),
            )}
            <>
              <Group
                title="Programa de Apadrinhamento"
                border={
                  ["83"].includes(idTipoPendencia)
                    ? "3px solid #4299E199"
                    : "#CACACA"
                }
                scrollToField={
                  ["83"].includes(idTipoPendencia) ? scrollToField : null
                }
              >
                <Grid
                  mt="15px"
                  templateColumns="repeat(3, 1fr)"
                  gap={
                    props.values?.mantemProgramaApadrinhamento === "S"
                      ? "25px"
                      : ""
                  }
                  rowGap={
                    props.values?.mantemProgramaApadrinhamento === "S"
                      ? "20px"
                      : ""
                  }
                >
                  <GridItem colSpan={{ base: 2, lg: 1 }} zIndex={"3"}>
                    <Field name="mantemProgramaApadrinhamento">
                      {({ field, form }) => (
                        <FormControl
                          isInvalid={
                            form.errors.mantemProgramaApadrinhamento &&
                            form.touched.mantemProgramaApadrinhamento
                          }
                          id="mantemProgramaApadrinhamento"
                          width="max-content"
                          zIndex={"999"}
                        >
                          <FormLabel
                            color="#5F6377"
                            whiteSpace={"nowrap"}
                            height={"10px"}
                            fontWeight="500"
                            fontSize="14px"
                            lineHeight="19.6px"
                            mb={6}
                          >
                            Serviço Mantém Programa de Apadrinhamento?*
                          </FormLabel>
                          <RadioGroup value={field.value}>
                            <Stack direction="row">
                              <RadioButtonField
                                fieldName="mantemProgramaApadrinhamento"
                                value="S"
                                label="Sim"
                              />
                              <RadioButtonField
                                fieldName="mantemProgramaApadrinhamento"
                                value="N"
                                label="Não"
                              />
                            </Stack>
                          </RadioGroup>
                          <FormErrorMessage mt="-1" mr="-14">
                            {form.errors.mantemProgramaApadrinhamento}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                  </GridItem>
                  <GridItem colSpan={{ lg: 2 }} />
                  {props.values.mantemProgramaApadrinhamento === "S" ? (
                    <GridItem colSpan={{ base: 2, lg: 1 }} zIndex={"1"}>
                      <FormLabel
                        color="#5F6377"
                        whiteSpace={"nowrap"}
                        height={"10px"}
                        fontWeight="500"
                        fontSize="14px"
                        lineHeight="19.6px"
                        mb={6}
                      >
                        Em Caso Positivo, esse Programa se Encontra Inscrito no
                        CMDCA?*
                      </FormLabel>
                      <Field name="programaInscritoCmdca">
                        {({ field, form }) => (
                          <FormControl
                            isInvalid={
                              form.errors.programaInscritoCmdca &&
                              form.touched.programaInscritoCmdca
                            }
                            id="programaInscritoCmdca"
                            width="max-content"
                            zIndex={"2"}
                          >
                            <RadioGroup value={field.value}>
                              <Stack direction="row">
                                <RadioButtonField
                                  fieldName="programaInscritoCmdca"
                                  value="S"
                                  label="Sim"
                                />
                                <RadioButtonField
                                  fieldName="programaInscritoCmdca"
                                  value="N"
                                  label="Não"
                                />
                              </Stack>
                              <FormErrorMessage mt="-1" mr="-14">
                                {form.errors.programaInscritoCmdca}
                              </FormErrorMessage>
                            </RadioGroup>
                          </FormControl>
                        )}
                      </Field>
                    </GridItem>
                  ) : (
                    ""
                  )}
                </Grid>
              </Group>

              <Flex mt="20px" justifyContent="flex-end">
                <Button
                  id="button-salvar"
                  type="submit"
                  translate="no"
                  color="#FFF"
                  backgroundColor="#169499"
                  fontWeight={700}
                  fontSize="15px"
                  lineHeight="21.6px"
                  _hover={{ bg: "#169499" }}
                  w="17%"
                  isLoading={props.isSubmitting}
                >
                  Salvar
                </Button>
              </Flex>
            </>
          </Form>
        )}
      </Formik>
    ) : (
      <Flex w="100%" mt="25%" justifyContent="center">
        <LoadingSpinner />
      </Flex>
    )
  ) : (
    <Box mt="2">
      <SemRegistros half buttonVisible={true} />
    </Box>
  );
};

export default CadastrarApadrinhamentoServico;
